import React, { useEffect } from "react"
import { useStore } from "../containers"
import { NotActive } from "../cells"
import { ConfigPage } from "../pages/ConfigPage"
import { LoadingPage } from "../LoadingPage"
import { Layout } from "./Layout"

export function Main() {
  const { active, loadOrg } = useStore()

  useEffect(() => {
    loadOrg()
    // @ts-ignore loadOrg não está memoized
  }, [])

  return (
    <LoadingPage>
      <Layout>{active ? <ConfigPage /> : <NotActive />}</Layout>
    </LoadingPage>
  )
}
